import PublicMobileModal, { PublicMobileModalProps } from 'components/PublicMobileModal'
import StatusPanel, { StatusPanelProps } from 'components/home/StatusPanel'

export interface SuccessModalProps extends
  Omit<PublicMobileModalProps, 'children'>,
  Omit<StatusPanelProps, 'className'>
{
  statusPanelClassName?: StatusPanelProps['className']
}

const SuccessModal = ({
  text,
  button,
  statusPanelClassName,
  ...props
}: SuccessModalProps) => {
  return (
    <PublicMobileModal
      className={{
        panel: props.className?.panel,
        ...props.className,
      }}
      {...props}
    >
      <StatusPanel
        text={text}
        button={button}
        className={statusPanelClassName}
      />
    </PublicMobileModal>
  )
}

export default SuccessModal
